<template>
    <div class="user-detail">
        <v-container>
            <v-card v-if="$gate.can('create_releaseStepHistories')">
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">send comment</v-card-title>
                <v-card-text>
                    <v-form v-model="valid">
                        <v-textarea label="comment" v-model="form.attributes.comment"></v-textarea>
                        <v-btn color="primary" @click="saveAction">
                            Comment
                        </v-btn>
                        <v-btn color="" @click="goBack">
                            Back
                        </v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
            <v-card class="mt-4">
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">comments</v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-tile v-for="item, index in form.relationships['releaseStepHistories'].data" :key="index" @click="">
                            <v-list-tile-content>
                                <v-list-tile-title v-text="item.attributes.author_id + ': ' + item.attributes.comment"></v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {

            if (this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('releaseHistories/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['releaseHistories/byId']({id: this.id});
                    this.form.attributes = widget.attributes;
                    this.form.id = widget.id;
                    this.form.type = widget.type;
                    const parent = widget;
                    this.$store.dispatch('releaseStepHistories/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['releaseStepHistories/related']({parent});
                        this.form.relationships['releaseStepHistories'].data = [];
                        this.form.relationships['releaseStepHistories'].data = related;
                    });
                });
            } else {

            }

        },
        methods: {
            ...mapActions({
                delete: 'releaseHistories/delete',
            }),
            goBack: function() {
              this.$router.back();
            },
            saveAction: function () {
                const recordData = {
                    attributes: {
                        comment: this.form.attributes.comment,
                        release_history_id: this.$route.params.id,
                    },
                };
                this.$store.dispatch('releaseStepHistories/create', recordData).then(() => {
                    var widget = {};
                    widget.attributes = this.form.attributes ;
                    widget.id = this.form.id;
                    widget.type = this.form.type;
                    const parent = widget;
                    this.$store.dispatch('releaseStepHistories/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['releaseStepHistories/related']({parent});
                        this.form.relationships['releaseStepHistories'].data = [];
                        this.form.relationships['releaseStepHistories'].data = related;
                        this.form.attributes.comment = '';
                    });
                });

            }

        },
        computed: {
            ...mapGetters({
                loading: "releaseHistories/isLoading",
                error: "releaseHistories/isError",
            }),
        },
        data: () => ({

            form: {
                attributes: {
                    comment: '',
                },
                relationships: {
                    'releaseStepHistories': {data: []},
                },
            },

            valid: false,
            id: null,
            title: '',
            titleRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ],
            releaseFlows: [],
            products: [],
        })
    }
</script>
